import { Box, Portal } from '@chakra-ui/react';
import MenuList from '@components/common/menu/MenuList';
import { useInfo } from '@hooks/useInfo';

export function MapInfoPicker() {
  const [ref, items, clickPosition] = useInfo();

  if (!items || !clickPosition) return;

  return (
    <Portal>
      <Box ref={ref} position="absolute" zIndex={4} top={clickPosition.y} left={clickPosition.x}>
        <MenuList menuItems={items} />
      </Box>
    </Portal>
  );
}
